"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryBuilder = void 0;
var _arcgisRestPortal = require("@esri/arcgis-rest-portal");
var _moment = _interopRequireDefault(require("moment"));
var _helper = require("./helper");
var _stateTypes = _interopRequireDefault(require("../store/stateTypes"));
var _filterGroupData = require("./filterGroupData");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var getTimeRanges = function getTimeRanges(_ref) {
  var id = _ref.id,
    startDate = _ref.startDate,
    endDate = _ref.endDate;
  var defaultEndDate = (0, _moment.default)().add(1, "day").endOf("day").valueOf();
  var splitRangeId = id.split("-")[0];
  switch (splitRangeId) {
    case "today":
      return {
        startDate: (0, _moment.default)().startOf("day"),
        endDate: defaultEndDate
      };
    case "yesterday":
      return {
        startDate: (0, _moment.default)().add(-1, "day").startOf("day"),
        endDate: defaultEndDate
      };
    case "last7Days":
      return {
        startDate: (0, _moment.default)().add(-7, "day").startOf("day"),
        endDate: defaultEndDate
      };
    case "last30Days":
      return {
        startDate: (0, _moment.default)().add(-30, "day").startOf("day"),
        endDate: defaultEndDate
      };
    default:
      // custom date range
      return {
        startDate: startDate,
        endDate: endDate
      };
  }
};

// on click of "Maps" item in ItemType group
// have hardcoded list of aliases
// switch statement referencing filters with aliases.  If no alias, build dynamically.  Will likely need to be both dynamic and hardcoded with alias

var getActiveOptions = function getActiveOptions(state) {
  var itemOptionGroups = [];
  var filteredItemOptions = Object.values(state.filters.itemOptions.byId).filter(function (option) {
    if (option.state === _stateTypes.default.FILTER_ITEM_OPTION_ACTIVE) {
      itemOptionGroups.push(option.group);
      return true;
    }
    return false;
  });
  var filteredItems = Object.values(state.filters.items.byId).filter(function (item) {
    return !itemOptionGroups.includes(item.id) && item.state === _stateTypes.default.FILTER_ITEM_ACTIVE;
  });
  return [].concat(_toConsumableArray(filteredItemOptions), _toConsumableArray(filteredItems));
};
var getActiveLayerType = function getActiveLayerType(activeItemOptions) {
  var activeLayerType = activeItemOptions.find(function (itemOption) {
    return _filterGroupData.specialLayerTypes.includes(itemOption.id);
  });
  if (activeLayerType) {
    return activeLayerType.id;
  }
  return null;
};
var queryBuilder = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var itemBrowserState, _ref2$itemBrowserOpti, showFolderFilter, queryScope, inclusiveFiltering, orgId, currentUsername, query, selectedFolder, activeItemOptions, activeLayerType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            itemBrowserState = _ref2.itemBrowserState, _ref2$itemBrowserOpti = _ref2.itemBrowserOptions, showFolderFilter = _ref2$itemBrowserOpti.showFolderFilter, queryScope = _ref2$itemBrowserOpti.queryScope, inclusiveFiltering = _ref2$itemBrowserOpti.inclusiveFiltering, orgId = _ref2.orgId, currentUsername = _ref2.currentUsername;
            query = new _arcgisRestPortal.SearchQueryBuilder();
            if (queryScope === "USER" && itemBrowserState.users.items.allIds.length) {
              // if false for include username, will not execute next line
              query.match(currentUsername).in("owner");
            }
            if (!showFolderFilter) {
              _context.next = 11;
              break;
            }
            selectedFolder = (0, _helper.getSelectedFolder)(itemBrowserState);
            if (!selectedFolder) {
              _context.next = 11;
              break;
            }
            _context.t0 = selectedFolder.id;
            _context.next = _context.t0 === "allmycontent" ? 9 : 10;
            break;
          case 9:
            return _context.abrupt("break", 11);
          case 10:
            query.and().match(selectedFolder.id).in("ownerfolder");
          case 11:
            if (queryScope === "ORGANIZATION") {
              query.match(orgId).in("orgid");
            }
            if (queryScope === "ONLINE") {
              query.match("public").in("access");
            }
            activeItemOptions = getActiveOptions(itemBrowserState);
            activeLayerType = getActiveLayerType(activeItemOptions);
            if (activeLayerType && activeLayerType === "tables") {
              query.and().startGroup().match("Table").in("typekeywords").endGroup();
            } else if (activeLayerType && activeLayerType === "tilelayers") {
              query.and().startGroup().match("WMTS").in("type").or().match("Map Service").in("type").or().match("Vector Tile Service").in("type").or().endGroup().and().startGroup().match("Hosted").in("typekeywords").or().match("Tiled").in("typekeywords").endGroup();
            } else {
              activeItemOptions.forEach(function (option, i) {
                var _getTimeRanges = getTimeRanges(option),
                  startDate = _getTimeRanges.startDate,
                  endDate = _getTimeRanges.endDate; // Bail out if there's no startDate/endDate
                // We don't want to add any query groups
                if ((option.field === "modified" || option.field === "uploaded") && (!startDate || !endDate)) {
                  return;
                }

                // Separate groups by "OR" when filtering inclusively
                if (i === 0 || !inclusiveFiltering) {
                  query.and().startGroup();
                  inclusiveFiltering && query.startGroup();
                } else {
                  query.or().startGroup();
                }
                switch (option.field) {
                  case "modified":
                  case "uploaded":
                    query.from(startDate).to(endDate).in(option.field);
                    break;
                  default:
                    option.query.forEach(function (queryString, index) {
                      query.match(queryString).in(option.field);
                      if (index !== option.query.length - 1) {
                        query.or();
                      }
                    });
                }
                query.endGroup();
              });
              inclusiveFiltering && query.endGroup();
              if (activeLayerType && activeLayerType === "featurelayers") {
                query.and().match("Table").in("-typekeywords");
              }
              if (activeLayerType && activeLayerType === "mapimagelayers") {
                query.startGroup().match("Hosted").in("-typekeywords").or().match("Tiled").in("-typekeywords").endGroup();
              }
            }
            return _context.abrupt("return", query);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function queryBuilder(_x) {
    return _ref3.apply(this, arguments);
  };
}();
exports.queryBuilder = queryBuilder;